<template>
  <div>
    <div style="margin-top: 5px">
      <div style="margin-bottom: -20px; position: relative; z-index: 1">
        <!-- chọn nhóm -->
        <el-select
            class="button-left"
            v-if="activeTabName === 'tabName2' "
            @change="changeSearchMethod"
            style="width: 250px"
            v-model="dataSearch.idGroup"
            placeholder="Chọn nhóm"
        >
          <el-option
              v-for="(item,index) in kidGroupList"
              :key="index"
              :value="item.id"
              :label="item.nameGroup"
          ></el-option>
        </el-select>
        <el-select
            v-if="activeTabName === 'tabName3' "
            class="button-left"
            style="width: 250px"
            v-model="dataSearch.idDepartment"
            @change="changeSearchMethod"
            placeholder="Phòng ban"
            clearable
        >
          <el-option
              v-for="(item,index) in departmentList"
              :key="index"
              :label="item.departmentName"
              :value="item.id"
          ></el-option>
        </el-select>
        <!-- chọn khối -->
        <el-select
            v-if="activeTabName === 'tabName1' "
            style="width: 250px"
            v-model="dataSearch.idGrade"
            @change="changeGradeSearch()"
            placeholder="Chọn khối"
        >
          <el-option
              v-for="item in gradeOfSchoolList"
              :key="item.id"
              :value="item.id"
              :label="item.gradeName"
          ></el-option>
        </el-select>

        <!-- chọn lớp -->
        <el-select
            v-if="activeTabName === 'tabName1'"
            class="button-left"
            style="width: 250px; margin-left: 5px"
            v-model="dataSearch.idClass"
            placeholder="Chọn lớp"
            @change="changeSearchMethod()"
        >
          <el-option
              v-for="item in classList"
              :key="item.id"
              :value="item.id"
              :label="item.className"
          ></el-option>
        </el-select>

      </div>

      <el-tabs type="card" @tab-click="handleClickTab" v-model="activeTabName">
        <!-- danh sách khoản các khoản trong một lớp -->
        <el-tab-pane label="Đăng ký theo lớp" name="tabName1">
          <el-table
              ref="multipleTable"
              :data="responseTab1DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeKids"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                width="55"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="targetName"
                min-width="170"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.birthday | formatDate }}</span>
              </template>
            </el-table-column
            >
            <!--             danh sách ca -->
            <el-table-column
                align="center"
                v-for="item in headerTab1List"
                :key="item.shiftId"
            >
              <!-- HEADER -->
              <template slot="header" slot-scope="scope">

                <el-popover
                    placement="top"
                    width="200"
                    trigger="hover"
                    :content="item.shiftName"
                >
      <span
          slot="reference"
          class="truncate-text"
          :title="item.shiftName"
      >
        {{ item.shiftName }}
      </span>
                </el-popover>

                <br/><br/>

                <!-- CHECK TOÀN CỘT -->
                <el-checkbox
                    v-model="item.assigned"
                    @change="checkHeaderPackageKidsMethod(scope.$index, item.shiftId, item.assigned)"
                ></el-checkbox>
              </template>

              <!-- BODY -->
              <template slot-scope="scope">
                <el-checkbox
                    :disabled="!scope.row.shiftAssignmentResponseList.find(x => x.shiftId === item.shiftId).assignAble"
                    v-model="scope.row.shiftAssignmentResponseList.find(x => x.shiftId === item.shiftId).assigned"
                    @change="updateHeaderOneShift(item.shiftId)"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column
                label="Tác vụ"
                fixed="right"
                width="150"
                align="center"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="updateShiftOneObject(scope.row)"
                >Thiết lập
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChangeClass"
                    @current-change="handleCurrentPageChangeClass"
                    :current-page.sync="dataSearch.page"
                    :page-sizes="listSizePage"
                    :total="totalClass">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-button
                    :loading="loadingButtonSaveTab1"
                    class="button-bottom"
                    type="success"
                    @click="activeShiftKidsManyMethod()"
                >Lưu
                </el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Đăng ký theo nhóm" name="tabName2">
          <el-table
              ref="multipleTable"
              :data="responseTab1DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeKids"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                width="55"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="targetName"
                min-width="170"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.birthday | formatDate }}</span>
              </template>
            </el-table-column
            >
            <!--             danh sách ca -->
            <el-table-column
                align="center"
                v-for="item in headerTab1List"
                :key="item.shiftId"
            >
              <!-- HEADER -->
              <template slot="header" slot-scope="scope">

                <el-popover
                    placement="top"
                    width="200"
                    trigger="hover"
                    :content="item.shiftName"
                >
      <span
          slot="reference"
          class="truncate-text"
          :title="item.shiftName"
      >
        {{ item.shiftName }}
      </span>
                </el-popover>

                <br/><br/>

                <!-- CHECK TOÀN CỘT -->
                <el-checkbox
                    v-model="item.assigned"
                    @change="checkHeaderPackageKidsMethod(scope.$index, item.shiftId, item.assigned)"
                ></el-checkbox>
              </template>

              <!-- BODY -->
              <template slot-scope="scope">
                <el-checkbox
                    :disabled="!scope.row.shiftAssignmentResponseList.find(x => x.shiftId === item.shiftId).assignAble"
                    v-model="scope.row.shiftAssignmentResponseList.find(x => x.shiftId === item.shiftId).assigned"
                    @change="updateHeaderOneShift(item.shiftId)"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column
                label="Tác vụ"
                fixed="right"
                width="150"
                align="center"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="updateShiftOneObject(scope.row)"
                >Thiết lập
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChangeClass"
                    @current-change="handleCurrentPageChangeClass"
                    :current-page.sync="dataSearch.page"
                    :page-sizes="listSizePage"
                    :total="totalClass">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-button
                    :loading="loadingButtonSaveTab1"
                    class="button-bottom"
                    type="success"
                    @click="activeShiftKidsManyMethod()"
                >Lưu
                </el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
        <el-tab-pane label="Đăng ký theo phòng ban" name="tabName3">
          <el-table
              ref="multipleTable"
              :data="responseTab1DataList"
              :empty-text="textTable"
              v-loading="loadingData"
              :element-loading-text="$tableLoading"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255,255,255, 0)"
              highlight-current-row
              :header-cell-style="tableHeaderColor"
              @selection-change="handleSelectionChangeKids"
              :max-height="$tableMaxHeight"
              border
          >
            <el-table-column
                type="selection"
                align="center"
                width="55"
            ></el-table-column>
            <el-table-column
                fixed
                type="index"
                label="STT"
                width="50"
                align="center"
            ></el-table-column>
            <el-table-column
                fixed
                prop="targetName"
                min-width="170"
                label="Họ tên"
            ></el-table-column>
            <el-table-column label="Ngày sinh" align="center" width="120">
              <template slot-scope="scope">
                <span>{{ scope.row.birthday | formatDate }}</span>
              </template>
            </el-table-column
            >
            <!--             danh sách ca -->
            <el-table-column
                align="center"
                v-for="item in headerTab1List"
                :key="item.shiftId"
            >
              <!-- HEADER -->
              <template slot="header" slot-scope="scope">

                <el-popover
                    placement="top"
                    width="200"
                    trigger="hover"
                    :content="item.shiftName"
                >
      <span
          slot="reference"
          class="truncate-text"
          :title="item.shiftName"
      >
        {{ item.shiftName }}
      </span>
                </el-popover>

                <br/><br/>

                <!-- CHECK TOÀN CỘT -->
                <el-checkbox
                    v-model="item.assigned"
                    @change="checkHeaderPackageKidsMethod(scope.$index, item.shiftId, item.assigned)"
                ></el-checkbox>
              </template>

              <!-- BODY -->
              <template slot-scope="scope">
                <el-checkbox
                    :disabled="!scope.row.shiftAssignmentResponseList.find(x => x.shiftId === item.shiftId).assignAble"
                    v-model="scope.row.shiftAssignmentResponseList.find(x => x.shiftId === item.shiftId).assigned"
                    @change="updateHeaderOneShift(item.shiftId)"
                ></el-checkbox>
              </template>
            </el-table-column>

            <el-table-column
                label="Tác vụ"
                fixed="right"
                width="150"
                align="center"
            >
              <template slot-scope="scope">
                <el-button
                    size="mini"
                    type="success"
                    @click="updateShiftOneObject(scope.row)"
                >Thiết lập
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-row type="flex">
            <el-col :span="22" style=" margin: 15px 0">
              <div class="container_nav_page">
                <el-pagination
                    background
                    layout="prev, pager, next, sizes"
                    @size-change="handleSizeChangeClass"
                    @current-change="handleCurrentPageChangeClass"
                    :current-page.sync="dataSearch.page"
                    :page-sizes="listSizePage"
                    :total="totalClass">
                </el-pagination>
              </div>
            </el-col>
            <el-col :span="2">
              <div style="float: right; margin: 15px 0">
                <el-button
                    :loading="loadingButtonSaveTab1"
                    class="button-bottom"
                    type="success"
                    @click="activeShiftKidsManyMethod()"
                >Lưu
                </el-button
                >
              </div>
            </el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
    </div>
    <UpdateShiftOneObjectDialog
        :teamId="teamId"
        :teamType="this.dataSearch.teamType"
        :targetType="this.dataSearch.targetType"
        :shiftList="shiftList"
        :isOpenUpdateShiftOneObjectDialog="isOpenUpdateShiftOneObjectDialog"
        @dialog-close="handleCloseUpdateShiftOneObjectDialog"
    />
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";
import revenueManagementService from "@/services/Finance_Kids_V2/RevenueManagementService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";
import UpdateShiftOneObjectDialog from "@/views/attendance-v2/dialog/UpdateShiftOneObjectDialog.vue";
import shiftMaster from "@/services/ShiftMaster";

export default {
  name: "RegisterShiftSubject",
  components: {
    UpdateShiftOneObjectDialog,
  },
  data() {
    return {
      textTable: "",
      loadingData: true,
      activeTabName: "tabName1",
      multipleSelectionKids: [],
      loadingButtonSaveTab1: false,
      responseTab1DataList: [],
      headerTab1List: [],
      dataSearch: {
        idClass: "",
        teamType: "CLASS",
        targetType: "STUDENT",
        limit: 25,
        page: 1,
        idGroup: "",
        idDepartment: "",
      },
      totalClass: 0,
      listSizePage: [25, 50, 100, 150, 200],
      shiftList: [],
      kidGroupList: [],
      type: "",
      teamId: "",
      isOpenUpdateShiftOneObjectDialog: false,
      classList: [],
    };
  },
  created() {
    this.$store.dispatch('gradeModule/fetchDataGradeOfSchoolList');
    this.$store.dispatch('departmentStore/fetchDataDepartmentList')
    this.$store.dispatch('classStore/fetchDataClassListCommon');
    this.getAllGroup();
  },
  computed: {
    ...mapState('gradeModule', ['gradeOfSchoolList']),
    ...mapState('classStore', ['classListCommon']),
    ...mapGetters('departmentStore', ['departmentList']),
  },
  watch: {
    gradeOfSchoolList: {
      immediate: true, // Kích hoạt ngay lập tức khi component được tạo
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdGrade();
        }
      },
    },
    classList: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.getIdClass();
        }
      },
    }
  },
  methods: {
    handleCloseUpdateShiftOneObjectDialog() {
      this.isOpenUpdateShiftOneObjectDialog = false;
      this.findAllByProperties()
    },
    tableHeaderColor() {
      return "background-color: #78a5e7;color: #fff;font-weight: bold;";
    },
    tableRowStyleDetail({row}) {
      if (row.expandRow) {
        return "font-weight: bold";
      }
    },
    async handleClickTab(tab) {
      let tabNameClick = tab.name;
      if (tabNameClick === "tabName1") {
        this.dataSearch.teamType = "CLASS"
        this.dataSearch.targetType = "STUDENT"
        await this.findAllByProperties();
      } else if (tabNameClick === "tabName2") {
        this.dataSearch.teamType = "GROUP"
        this.dataSearch.targetType = "STUDENT"
        await this.findAllByProperties();
      } else if (tabNameClick === "tabName3") {
        this.dataSearch.teamType = "DEPARTMENT"
        this.dataSearch.targetType = "TEACHER"
        this.dataSearch.idDepartment = this.departmentList[0].id
        await this.findAllByProperties();
      }
    },
    handleSelectionChangeKids(val) {
      this.multipleSelectionKids = val;
    },

    checkBeforeSelect(list) {
      if (list.length === 0) {
        NotifyMessage.leftCornerNotificationError("Không có học sinh nào được chọn!")
        throw null;
      }
    },

    /**
     * click check header ở ca mặc định
     */
    checkHeaderPackageKidsMethod(index, shiftId, value) {
      this.responseTab1DataList.forEach(student => {
        const shift = student.shiftAssignmentResponseList.find(s => s.shiftId === shiftId);
        if (shift) shift.assigned = value;
      });
    },


    /**
     * Sửa chi tiết ca cho học sinh
     */
    updateShiftOneObject(row) {
      this.shiftList = row.shiftAssignmentResponseList;
      console.log(this.shiftList);
      this.isOpenUpdateShiftOneObjectDialog = true;
    },
    /**
     * kích hoạt/hủy kích hoạt ca cho nhiều học sinh
     */
    activeShiftKidsManyMethod() {
      let selectRowList = this.multipleSelectionKids;
      this.checkBeforeSelect(selectRowList);
      let data = []
      if (this.activeTabName === "tabName1") {
        this.teamId = this.dataSearch.idClass
      } else if (this.activeTabName === "tabName2") {
        this.teamId = this.dataSearch.idGroup
      } else if (this.activeTabName === "tabName3") {
        this.teamId = this.dataSearch.idDepartment
      }
      this.multipleSelectionKids.forEach((x) => {
        x.shiftAssignmentResponseList.forEach((y) => {
          let object = {
            shiftId: y.shiftId,
            targetId: x.targetId,
            teamId: this.teamId,
            teamType: this.dataSearch.teamType,
            targetType: this.dataSearch.targetType,
            assignment: y.assigned
          }
          data.push(object);
        })
      })
      shiftMaster.createShiftAssignments(data)
          .then(() => {
            NotifyMessage.leftCornerNotificationSuccess("Lưu thay đổi thành công")
            this.findAllByProperties();
          })
          .catch(() => {
            NotifyMessage.leftCornerNotificationError("Lưu thay đổi thất bại");
          })
          .finally(() => {
            setTimeout(() => {
              this.loadingButtonSaveTab1 = false;
            }, 500);
          });
    },


    async changeSearchMethod() {
      if (this.activeTabName === "tabName1") {
        this.dataSearch.teamType = "CLASS"
        this.dataSearch.targetType = "STUDENT"
        await this.findAllByProperties();
      } else if (this.activeTabName === "tabName2") {
        this.dataSearch.teamType = "GROUP"
        this.dataSearch.targetType = "STUDENT"
        await this.findAllByProperties();
      } else if (this.activeTabName === "tabName3") {
        this.dataSearch.teamType = "DEPARTMENT"
        this.dataSearch.targetType = "TEACHER"
        await this.findAllByProperties();
      }
    },
    /**
     * đối khối
     */
    changeGradeSearch() {
      this.classList = this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade)
    },

    getIdGrade() {
      this.dataSearch.idGrade = this.gradeOfSchoolList[0].id;
      this.classList = this.classListCommon.filter((x) => x.idGrade === this.dataSearch.idGrade)
    },
    getIdClass() {
      this.dataSearch.idClass = this.classList[0].id;
      this.changeSearchMethod();
    },

    /**
     * tìm kiếm các ca theo lớp
     */
    async findAllByProperties() {
      this.textTable = "";
      this.loadingData = true;
      this.headerTab1List = []
      this.responseTab1DataList = []
      if (this.activeTabName === "tabName1") {
        this.teamId = this.dataSearch.idClass
      } else if (this.activeTabName === "tabName2") {
        this.teamId = this.dataSearch.idGroup
      } else if (this.activeTabName === "tabName3") {
        this.teamId = this.dataSearch.idDepartment
      }
      await shiftMaster.getShiftAssignmentsByTarget(
          this.teamId, this.dataSearch.teamType, this.dataSearch.targetType, this.dataSearch.page, this.dataSearch.limit
      )
          .then((resp) => {
            this.responseTab1DataList = resp.data.data.content;
            this.totalClass = resp.data.data.totalElements
            this.headerTab1List = this.responseTab1DataList[0].shiftAssignmentResponseList;
            this.initHeaderAssigned();
          })
          .catch((err) => {
            NotifyMessage.leftCornerNotificationError(err.response.data.message)
            this.responseTab1DataList = [];
            this.headerTab1List = [];
          })
          .finally(() => {
            if (this.responseTab1DataList.length === 0) {
              this.textTable = this.$tableEmpty;
            }
            setTimeout(() => {
              this.loadingData = false;
            }, 300);
          });
    },
    initHeaderAssigned() {
      this.headerTab1List = this.headerTab1List.map(item => {
        // kiểm tra xem tất cả học sinh có assigned=true cho ca này không
        const allActive = this.responseTab1DataList.every(student =>
            student.shiftAssignmentResponseList.find(s => s.shiftId === item.shiftId).assigned === true
        );

        return {
          ...item,
          assigned: allActive   // gán trạng thái cho header checkbox
        };
      });
    },
    updateHeaderOneShift(shiftId) {
      const allActive = this.responseTab1DataList.every(student =>
          student.shiftAssignmentResponseList.find(s => s.shiftId === shiftId).assigned === true
      );

      const headerItem = this.headerTab1List.find(h => h.shiftId === shiftId);
      if (headerItem) headerItem.assigned = allActive;
    },

    /**
     * tìm tất cả các nhóm trong một trường
     */
    getAllGroup() {
      revenueManagementService.getListKidsGroup().then((res) => {
        this.kidGroupList = res.data
        if (this.kidGroupList.length > 0) {
          this.dataSearch.idGroup = this.kidGroupList[0].id
        }
      }).catch(() => {
        NotifyMessage.leftCornerNotificationError("Lỗi dữ liệu!")
      })
    },
    handleSizeChangeClass(value) {
      this.dataSearch.limit = value;
      this.findAllByProperties();
    },
    handleCurrentPageChangeClass(value) {
      this.dataSearch.page = value;
      this.findAllByProperties();
    },

  },

};
</script>

<style lang="scss" scoped>
/deep/ .el-tabs__nav {
  background: #a0a19ce0;
}

/deep/ .el-tabs__item {
  color: white;
}

/deep/ .el-tabs__item.is-active {
  color: white;
  background: #78a5e7;
}

/deep/ .el-form-item__label {
  font-family: Arial, Helvetica, sans-serif;
}

/deep/ .el-tabs__nav-scroll {
  float: right;
}

/deep/ .el-tabs__header {
  margin-bottom: 0;
}

/deep/ .el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  border-bottom-color: #78a5e7;
}

/deep/ .el-tabs--card > .el-tabs__header {
  border-bottom: none;
}

/deep/ .el-table .cell {
  line-height: 15px;
}

/deep/ .el-table th > .cell {
  font-size: 13px;
}

/deep/ .el-checkbox__inner {
  border: 1px solid gray;
}

/deep/ .el-table td {
  padding: 8px 0;
}

/deep/ .el-table th {
  padding: 12px 0;
}

/deep/ .el-icon-arrow-right:before {
  content: "";
}

.input-common {
  margin-right: 5px;
}

.button-bottom {
  border-radius: 0;
  margin-left: 5px;
}

.button-click {
  float: right;
  margin: 20px 0 40px 0;
}

.el-dropdown-menu {
  position: absolute;
  top: 0;
  left: 0;
  padding: 0 0;
  margin: 3px 0;
  background-color: #5fb44a;
  border: 1px solid #ebeef5;
  border-radius: 0;
  box-shadow: 0 2px 12px 0 #0000001a;
}

.el-dropdown-menu li {
  color: white;
  border-top: 1px solid white;
  font-family: Arial, Helvetica, sans-serif;
}

.over-table {
  width: 97%;
  margin: 0 auto;
}

.table-data {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #ebeef5;

  // display: inline-block;
}

.wrapper-table {
  height: 600px;
  overflow-y: scroll;
  border-bottom: 1px solid #ebeef5;
}

thead {
  background: #78a5e7;
  color: white;
  font-weight: bold;
  // display: block;
  // width: 90%;
}

tbody {
  color: #606266;
  font-size: 14px;
  overflow: auto;
  font-family: Arial, Helvetica, sans-serif;
}

td {
  padding: 12px;
}

.table-index {
  width: 10px;
  text-align: center;
}

.table-item-name {
  width: 200px;
  text-align: center;
}

.table-action {
  width: 200px;
  text-align: center;
}

.color-text-reply {
  color: #4177e2;
}

.input-data {
  width: 60%;
}

.disable-row {
  background: #e4e7ed;
}

.truncate-text {
  display: inline-block;
  max-width: 150px; /* điều chỉnh theo cần thiết */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: middle;
}

.button-left {
  margin-right: 5px;
  width: 150px;
}

.container_nav_page {
  display: flex;
  justify-content: center;
}
</style>
